import { CSSObject } from '@emotion/react'
import { colors } from '@opallabs/spectrum'
import { postWidth } from '../../styles'

export const captionContainer: CSSObject = {
  padding: '6px 11px',
}

export const contentAsset = (hasAsset: boolean): CSSObject => ({
  backgroundColor: hasAsset ? '#000' : colors.n8.base,
  display: 'flex',
  height: 544,
  width: postWidth,
  video: {
    maxBlockSize: 544,
    minBlockSize: '100%',
    inlineSize: postWidth,
    objectFit: 'contain',
  },
  img: {
    maxBlockSize: 544,
    inlineSize: postWidth,
    objectFit: 'cover',
  },
})
